module.exports = __webpack_public_path__ + "img/no-signal.c15d4343.svg";